import { pick } from 'lodash';
import { put, call, select } from 'redux-saga/effects';

import { UnverifiedEmailLoginError } from '@epi-constants/login';
import { getLoginState } from '@epi-selectors/login';
import storage from '@epi-helpers/StorageHelper';

import { goToPage, goToReturnPage } from '@epi-actions/navigation';
import { clearLoginOtpState, setLoginOtpState } from '@epi-actions/login';
import {
  userLogin,
  userLoginOtpVerify
} from '../../repositories/LoginRepository';
import { routerPaths } from '../../constants/routerPaths';
import { SetAuthorizationData } from '../../helpers/AuthorizeHelper';
import { ApiConstants, ApplicationConstants } from '../../constants/actions';
import * as overlaysActions from '../../actions/overlays';
import { hasOrders as hasOrdersRepo } from '../../repositories/UserRepository';

export function* ApiLogin({ payload, isAutoLogin, autoRedirect }) {
  try {
    const loginResponse = yield call(userLogin, payload);
    if (loginResponse?.otpPinId) {
      yield put(
        setLoginOtpState({
          otpPinId: loginResponse.otpPinId,
          rememberMe: payload.rememberMe
        })
      );
      yield put({ type: `${ApiConstants.CLEAR_API_ERROR}` });
      yield put(goToPage(routerPaths.loginOtpVerification));
      return;
    }

    yield call(completeLoginSuccess, {
      loginResponse,
      rememberMe: payload.rememberMe,
      isAutoLogin,
      autoRedirect
    });
  } catch (error) {
    if (error.content.errors[0].code === UnverifiedEmailLoginError) {
      yield put({
        type: `${ApiConstants.LOGIN_ACTION}_UNVERIFIED`,
        payload: { ...error, username: payload.username },
        isError: true
      });
    } else {
      yield put({
        type: `${ApiConstants.LOGIN_ACTION}_FAILURE`,
        payload: error,
        isError: true
      });
    }
  }
}

export function* ApiLoginOtpVerify({ payload }) {
  const loginState = yield select(getLoginState);
  const { otpPinId, rememberMe } = loginState;

  if (!otpPinId) {
    yield put({ type: `${ApiConstants.LOGIN_OTP_VERIFY_ACTION}_ABORT` });
    yield put(clearLoginOtpState());
    yield put(goToPage(routerPaths.login));
    return;
  }

  try {
    const loginResponse = yield call(userLoginOtpVerify, {
      pinId: otpPinId,
      pin: payload.pin
    });

    yield put({ type: `${ApiConstants.LOGIN_OTP_VERIFY_ACTION}_SUCCESS` });
    yield put(clearLoginOtpState());

    yield call(completeLoginSuccess, {
      loginResponse,
      rememberMe: rememberMe,
      isAutoLogin: false,
      autoRedirect: false
    });
    yield put(goToPage(routerPaths.home));
  } catch (error) {
    yield put({
      type: `${ApiConstants.LOGIN_OTP_VERIFY_ACTION}_FAILURE`,
      payload: error,
      isError: true
    });
  }
}

function* completeLoginSuccess({
  loginResponse,
  rememberMe,
  isAutoLogin,
  autoRedirect
}) {
  yield call(SetAuthorizationData, loginResponse);
  const hasOrders = yield call(hasOrdersRepo);
  yield put({
    type: `${ApiConstants.GET_HAS_ORDERS}_LOADED`,
    payload: { hasOrders }
  });
  if (rememberMe === true) {
    const authenticationData = pick(yield select(getLoginState), [
      'isAuthenticated',
      'accessToken',
      'tokenType',
      'refreshToken',
      'expiresIn',
      'validTo',
      'roles',
      'hasOrders'
    ]);
    storage.set('rememberMe', authenticationData);
  }

  if (autoRedirect) {
    yield put(goToReturnPage());
  }
  yield put({ type: `${ApplicationConstants.CLEAN_COMPANY_EXISTS_INFO}` });

  if (!isAutoLogin) {
    yield put(
      overlaysActions.showNotification(
        { message: 'messages.successful_login' },
        'success'
      )
    );
  }
  yield put({
    type: `${ApiConstants.CLEAR_API_ERROR}`
  });
}
